/** @format */
import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, ViewEncapsulation } from '@angular/core';
import { CustomStudyDraft, StudyPeriodLocator } from 'common-typescript/types';
import { customStudyDraftInfoModalOpener, StudyBoxType } from 'sis-components';

@Component({
    selector: 'app-timeline-custom-study-draft',
    standalone: false,
    templateUrl: './timeline-custom-study-draft.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineCustomStudyDraftComponent {
    readonly customStudyDraft: InputSignal<CustomStudyDraft> = input.required<CustomStudyDraft>();
    readonly headingLevel: InputSignal<number> = input.required<number>();
    readonly currentPeriod: InputSignal<StudyPeriodLocator> = input.required<StudyPeriodLocator>();

    protected readonly plannedPeriods: Signal<StudyPeriodLocator[] | undefined> = computed(() => this.customStudyDraft()?.plannedPeriods);

    protected readonly StudyBoxType = StudyBoxType;
    protected readonly openCustomStudyDraftInfoModal = customStudyDraftInfoModalOpener();
}
